import { WarehouseStepText } from "./types";

export const WAREHOUSE_INFO_STEP = 0;
export const WAREHOUSE_ADDRESS_STEP = 1;
export const WAREHOUSE_WORKING_HOURS_STEP = 2;
export const WAREHOUSE_CONTACTS_STEP = 3;

/** Naslov i objašnjenje ispod scene, po koraku. */
export const WAREHOUSE_INTRO_TEXTS: Record<number, WarehouseStepText> = {
  [WAREHOUSE_INFO_STEP]: {
    title: "Otvorite novo skladište",
    description: "Dajte skladištu naziv i opis. Na njemu se vode gume i oprema vozila, pa se uvijek zna što je gdje.",
  },
  [WAREHOUSE_ADDRESS_STEP]: {
    title: "Gdje se skladište nalazi?",
    description: "Označite lokaciju na karti ili upišite adresu. Po njoj se skladište lako pronađe.",
  },
  [WAREHOUSE_WORKING_HOURS_STEP]: {
    title: "Kada skladište radi?",
    description: "Upišite radno vrijeme po danima. Tako se zna kada se gume i oprema mogu preuzeti.",
  },
  [WAREHOUSE_CONTACTS_STEP]: {
    title: "Tko je zadužen za skladište?",
    description: "Dodajte kontakte skladišta, pa se zna koga nazvati kad treba preuzeti gume ili opremu.",
  },
};

/** Primjeri dok korisnik ništa nije upisao. */
export const WAREHOUSE_INTRO_SAMPLE = {
  name: "Skladište Jankomir",
  addressLine: "Jankomir 25",
  addressCity: "10000 Zagreb, Hrvatska",
  latitude: 45.7967,
  longitude: 15.8616,
  contacts: [
    { name: "Ivan Kovač", role: "Voditelj skladišta", initials: "IK" },
    { name: "Ana Babić", role: "Prijem guma", initials: "AB" },
  ],
};

/** Popunjenost skladišta u sceni osnovnih podataka. */
export const WAREHOUSE_INTRO_STOCK = [
  { name: "Ljetne gume", count: "86 kompleta", width: "w-4/5" },
  { name: "Zimske gume", count: "52 kompleta", width: "w-1/2" },
  { name: "Oprema", count: "24 komada", width: "w-1/4" },
];
